
import { defineComponent, ref } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import useAuth from "@/auth/composables/useAuth";
import personImg from "@/assets/person.png";
export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const { image } = useAuth();
    let imagen = ref("");
    if (image.value.length < 100) {
      imagen.value =
        personImg;
    } else {
      imagen.value = image.value;
    }
    return {
      imagen,
    };
  },
});
